import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=406d8cf5"
import script from "./PageFooter.vue?vue&type=script&lang=js"
export * from "./PageFooter.vue?vue&type=script&lang=js"
import style0 from "./PageFooter.vue?vue&type=style&index=0&id=406d8cf5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports